import React, { useState } from "react";

import { getValue } from "../../utils";

import { Div, CancelIcon } from "components/Base";
import MiniModalWrapper from "ui-kit/MiniModalWrapper";

import { IFrame } from "SendEmailModal/View/Scenes/Review/BuildIframe";

import { noop } from "utils/General";
import { ROW_ACTIONS } from "../../constants";

import { connect } from "react-redux";
import { bindInstance } from "redux-mvc";

import { actions } from "../../model";

const IframePopup = ({ closeModal = noop, content }) => (
  <MiniModalWrapper
    hideModal={closeModal}
    isPortal={false}
    showModal={true}
    showHeader={false}
    zIndex={300}
    style={{
      width: "90%",
      backgroundColor: "white",
      height: "90vh"
    }}
    bg="neutral0"
  >
    <div
      onClick={closeModal}
      style={{
        backgroundColor: "white",
        position: "absolute",
        top: "3vh",
        height: "36px",
        width: "36px",
        right: "4%",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer"
      }}
    >
      <CancelIcon color="neutral8" sizeWFS={12} />
    </div>
    <Div
      bg="white"
      width={1}
      height={1}
      display="column.flex-start.stretch"
      p={4}
      bt={1}
      bc="neutral2"
      style={{
        overflowY: "auto"
      }}
    >
      <IFrame
        style={{
          width: "100%",
          height: "100%",
          border: 0
        }}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: content
          }}
        />
      </IFrame>
    </Div>
  </MiniModalWrapper>
);

const decorate = connect(
  null,
  bindInstance({
    execute: actions.executeAction
  })
);

const IframeOverlay = props => {
  const [showModal, setShowModal] = useState(false);

  const label = getValue(props, "label");
  let content = getValue(props, "content");

  const {
    data: { show_logs = undefined, id = null, counts = {} } = undefined,
    field = null,
    data = {}
  } = props;

  let types = null;
  if (show_logs) {
    const {
      value: { show_logs: show_logss = undefined } = undefined
    } = show_logs;
    const { id } = field;
    types = data[id].value.type;
    if (!show_logss) {
      return (
        <div
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%"
          }}
        >
          -
        </div>
      );
    }
  }

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%"
      }}
    >
      <div
        title={label}
        className="underline-on-hover"
        style={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#2e70e2",
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          cursor: "pointer"
        }}
        onClick={() => {
          if (show_logs === undefined || types === "counts") {
            if (types === "counts") {
              const { content: newContent = null } = counts;
              content = newContent;
            }
            setShowModal(true);
          } else if (types === "logs") {
            props.execute({
              actionId: ROW_ACTIONS.OPEN_SYNC_LOG_MODAL,
              id
            });
          }
        }}
      >
        {label}
      </div>
      {showModal && (
        <IframePopup content={content} closeModal={() => setShowModal(false)} />
      )}
    </div>
  );
};
export default decorate(IframeOverlay);
